<template>
  <div class="stb-container">
    <search-zone-picker/>
    <search-dates/>
    <search-travelers/>
    <button class="btn-std stb-item" @click="runSearch" :disabled="requesting || !datePicked">
      {{ $t('roomFinder.inputSearch') }}
    </button>
  </div>
</template>

<script>
import SearchZonePicker from "../picker/search-zone-picker";
import SearchDates from "../picker/search-dates";
import SearchTravelers from "../picker/search-travelers";
import {mapState} from "vuex";

export default {
  name: "search-top-bar",
  components: {SearchTravelers, SearchDates, SearchZonePicker},
  computed: {
    ...mapState({
      requesting: s => s.search.requesting,
    }),
    datePicked() {
      return this.$store.getters['search/hasDates']
    }
  },
  methods: {
    runSearch() {
      if (this.requesting || !this.datePicked) return;
      this.$store.commit('search/SET_MAP_SELECTED', []);
      this.$emit('action-search');
    }
  }
}
</script>

<style scoped>
button:disabled {
  opacity: .5;
  cursor: wait;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/parts/search-top-bar.vue